import {useEffect, useState} from 'react'
import {Link, useParams} from 'react-router-dom'
import {app_id, BASE_URL} from '../../config'
import axios from 'axios'
import {InvoiceResponse} from '../core/_model'
import {useQuery} from 'react-query'
import {Content} from '../../../../_metronic/layout/components/content'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import {formatDate, setAvatarDefault} from '../../../utils/helperFunction/_helper'
import html2pdf from 'html2pdf.js'
import {Helmet} from 'react-helmet-async'
import {useThemeMode} from '../../../../_metronic/partials'
import {useUserStateProvider} from '../../../utils/contextProvider/UserStateProvider'

const GET_INVOICE_BY_ID = `${BASE_URL}/api/protect/getInvoiceById?invoiceId=`

const InvoiceView = () => {
  const {id} = useParams()
  const {updateMode} = useThemeMode()
  const {
    userAttachments: {userprofile},
  } = useUserStateProvider()

  const {isLoading, data, error} = useQuery({
    queryKey: ['invoiceview', id],
    queryFn: async () => {
      const response = await axios.get<InvoiceResponse>(`${GET_INVOICE_BY_ID}${id}`)
      return response.data
    },
    onError: (error) => {
      console.error(error)
    },
  })

  const downloadInvoice = () => {
    const element = document.getElementById('invoice')
    if (!element) return

    const wrapper = document.createElement('div')
    wrapper.style.position = 'absolute'
    wrapper.style.left = '-999999px'
    const clone = element.cloneNode(true) as HTMLElement
    wrapper.appendChild(clone)
    document.body.appendChild(wrapper)

    const titles = Array.from(wrapper.getElementsByClassName('subtitle')) as HTMLElement[]
    const trEls = Array.from(wrapper.getElementsByClassName('tr')) as HTMLElement[]
    const elements = Array.from(wrapper.getElementsByClassName('text-gray-900')) as HTMLElement[]
    const border = wrapper.querySelector('.border-gray-900') as HTMLElement

    console.log(border)

    titles.forEach((el) => {
      el.style.color = 'black'
    })
    trEls.forEach((el) => {
      el.style.color = 'black'
    })
    elements.forEach((el) => {
      el.style.color = 'black'
      el.classList.remove('text-gray-900')
      el.style.fontSize = '12px'
    })
    border.style.borderColor = 'black'

    const opt = {
      margin: [0.5, 0.5, 0.5, 0.5],
      filename: `invoice-${data?.invoiceInfo?.invoice_no || 'file'}.pdf`,
      image: {type: 'jpeg', quality: 0.98},
      html2canvas: {
        scale: 3,
        logging: true,
        allowTaint: true,
        useCORS: true,
        backgroundColor: '#ffffff',
        windowHeight: 1400,
      },
      jsPDF: {unit: 'in', format: 'letter', orientation: 'portrait', compress: false},
    }

    html2pdf()
      .set(opt)
      .from(clone)
      .save()
      .then(() => {
        document.body.removeChild(wrapper)
      })
  }

  let contentHelmet = (
    <Helmet>
      <title>Invoice View</title>
    </Helmet>
  )

  if (isLoading) {
    return (
      <Content>
        {contentHelmet}
        <div className='d-flex justify-content-center align-items-center'>
          <div className='spinner-border' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </div>
        </div>
      </Content>
    )
  }

  if (error) {
    return (
      <Content>
        {contentHelmet}
        <p className='text-center fs-3 text-danger'>Error loading invoice.</p>
      </Content>
    )
  }

  if (!data || !data.invoiceInfo) {
    return (
      <Content>
        {contentHelmet}
        <p className='text-center fs-3 text-gray-800 fw-semibold'>No Invoice Found.</p>
      </Content>
    )
  }

  return (
    <Content>
      {contentHelmet}
      <KTCard className='h-900px w-full mw-1000px mx-auto'>
        <KTCardBody>
          <div className='text-end'>
            <button type='button' className='btn btn-success' onClick={downloadInvoice}>
              Download
            </button>
            {app_id === 0 && (
              <Link to='/Billing/Invoice/preview' className='ms-5'>
                Version 2
              </Link>
            )}
          </div>
          <div id='invoice'>
            <div className='d-flex justify-content-between align-items-center mb-8 border-b-2 border-gray-800'>
              <img
                src={setAvatarDefault(userprofile)}
                alt='iatl'
                className='object-fit-contain w-100px h-100px'
              />

              <div>
                <h3 className='fs-2x subtitle'>INVOICE</h3>
                <p className='fs-6 mb-0 text-gray-900 fw-bold'>
                  Invoice No: {data.invoiceInfo.invoice_no}
                </p>
                <p className='fs-6 mb-0 text-gray-900 fw-bold'>
                  Invoice Date: {formatDate(data.invoiceInfo.invoice_date)}
                </p>
              </div>
            </div>

            <div className='border border-gray-900 border-2'></div>

            <div className='my-4 d-flex justify-content-between'>
              <div>
                <p className='fs-2 mb-0 text-gray-900 fw-bold'>BILL TO</p>
                <p className='fs-6 mb-0 text-gray-900 fw-bold'>
                  {data.toBillDetails.user_full_name}
                </p>
                <p className='fs-6 mb-0 text-gray-900 fw-bold'>{data.toBillDetails.user_email}</p>
                <p className='fs-6 mb-0 text-gray-900 fw-bold'>{data.toBillDetails.user_mobile}</p>
                {/* <p className='fs-6 mb-0 text-gray-900 fw-bold'>{data.toBillDetails.create_date}</p> */}
              </div>

              <div>
                <p className='fs-2 mb-0 text-gray-900 fw-bold'>BILLING PERIOD</p>
                <p className='fs-6 mb-0 text-gray-900 fw-bold'>
                  Start Date: {data.invoiceInfo.start_date}
                </p>
                <p className='fs-6 mb-0 text-gray-900 fw-bold'>
                  End Date: {data.invoiceInfo.end_date}
                </p>
                <p className='fs-6 mb-0 text-gray-900 fw-bold'>Currency: BDT</p>
              </div>
            </div>

            <div className='my-15'>
              <h3 className='mb-3 subtitle'>INVOICE SUMMARY:</h3>

              <table className='table table-bordered border border-gray-800'>
                <thead>
                  <tr className='fw-bolder fs-6 text-gray-900'>
                    <th>SMS Count</th>
                    {/* <th>SMS Hit</th> */}
                    <th>Cost</th>
                    <th>Vat</th>
                    <th>Service Charge</th>
                    {/* <th>Total Cost</th> */}
                  </tr>
                </thead>

                <tbody>
                  <tr className='tr'>
                    <td>{data.invoiceInfo.sms_count}</td>
                    {/* <td>{data.invoiceInfo.sms_hit}</td> */}
                    <td>{data.invoiceInfo.user_cost}</td>
                    <td>{data.invoiceInfo.vat}</td>
                    <td>{data.invoiceInfo.service_charge}</td>
                  </tr>
                  <tr className='tr'>
                    <td colSpan={3}>Total</td>
                    <td>{data.invoiceInfo.total_cost}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div>
              <h3 className='mb-6 subtitle'>ACCOUNT SUMMARY:</h3>

              <div className='mb-8'>
                <p className='fs-4 text-gray-900 mt-2 fs-4'>
                  Balance:{' '}
                  <span className='font-bold text-gray-900 fs-4'>
                    {data.invoiceInfo.user_balance} BDT
                  </span>
                </p>
                <p className='fs-4 text-gray-900 mt-2 fs-4'>
                  Total Cost:{' '}
                  <span className='font-bold text-gray-900 fs-4'>
                    {data.invoiceInfo.total_cost} BDT
                  </span>
                </p>
              </div>

              {/* <table className='table table-bordered border border-gray-800'>
                <thead>
                  <tr className='fw-bolder fs-6 text-gray-900'>
                    <th>Balance</th>
                    <th>{data.invoiceInfo.user_balance}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr className='tr'>
                    <td>Total Cost</td>
                    <td>{data.invoiceInfo.total_cost}</td>
                  </tr>
                </tbody>
              </table> */}
            </div>
          </div>
        </KTCardBody>
      </KTCard>
    </Content>
  )
}

export default InvoiceView
